var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1IndoorSiren(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.84 4.61L6 25.3V66h65V25.31L38.84 4.61zM67 62H10V27.5L38.82 9.35 67 27.49V62zM54.82 41.09a16.84 16.84 0 00-5-12L52 27a19.86 19.86 0 01.25 27.9l-2.27-2a16.83 16.83 0 004.84-11.81zm-6.09 0a10.77 10.77 0 00-3.4-7.86l2.19-2.06a13.792 13.792 0 01.09 19.75l-2.29-2a10.8 10.8 0 003.41-7.83zm-5.83 5.78l-2.27-2v-.07a4.6 4.6 0 00.17-7.36L43 35.4a7.621 7.621 0 01-.11 11.47h.01zm-5.73.13h-4.92v1.75A1.25 1.25 0 0131 50h-3.5a1.25 1.25 0 01-1.25-1.25V47h-5.07s3.88-12.5 4.29-13.09A4 4 0 0129.18 32h.32a4 4 0 013.79 2.59v.08c.26.71 1.79 5.63 2.84 9 .16.51.31 1 .44 1.41l.24.76c.19.61.32 1 .36 1.16z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Indoor_siren.289f48c9.svg";
export { SvgG1IndoorSiren as ReactComponent };